var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-image",
    _vm._g(
      _vm._b(
        {
          ref: "image-previewer",
          attrs: { src: _vm.src, "preview-src-list": _vm.previewSrcList },
        },
        "el-image",
        _vm.$attrs,
        false
      ),
      _vm.$listeners
    ),
    [
      _c(
        "div",
        { staticClass: "image-slot", attrs: { slot: "error" }, slot: "error" },
        [
          _c("img", {
            staticStyle: {
              width: "100%",
              height: "100%",
              "object-fit": "contain",
            },
            attrs: {
              slot: "error",
              src: require("@/assets/image/tupianjiazaishibai.png"),
              alt: "",
            },
            slot: "error",
          }),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }